module.exports = __webpack_public_path__ + "img/seafood.280e7132.svg";